import { createSlice } from '@reduxjs/toolkit';

const initialState = {
};

export const startCourseSlice = createSlice({
    name: 'startCourseSlice',
    initialState,
    reducers: {
        
    },
});

// export const { setShowCongratsStatus } = startCourseSlice.actions;
export default startCourseSlice.reducer;